import { StyleProp, StyleSheet, Text, View, ViewStyle } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { tRenderBadges, tRowData } from "./types";

/**
 * @param {keyof T} myColumnKey - the name of the column, used to index the row object
 * @param {tRowData<T, C>} row - the row data
 * @returns {JSX.Element} the table cell, proper padding and cell truncation
 */
export const defaultRenderCell: <T, C>(myColumnKey: keyof T, row: tRowData<T, C>) => JSX.Element = (
  myColumnKey,
  row,
) => {
  const kCellVal = row[myColumnKey];
  if (kCellVal instanceof Date && !!kCellVal.toLocaleDateString)
    return (
      <Text style={styles.gTableCellText} numberOfLines={1} ellipsizeMode="tail">
        {kCellVal.toLocaleDateString("en-US")}
      </Text>
    );
  else if (typeof kCellVal === "string") return renderDefaultCell(kCellVal);
  return <></>;
};

export const defaultCell = (value: string): JSX.Element => (
  <Text style={styles.gTableCellText} numberOfLines={1} ellipsizeMode="tail">
    {value}
  </Text>
);

export const renderDefaultCell: (myVal: string | Date | number) => JSX.Element = (myVal) => {
  let aVal: string | number;
  if (myVal instanceof Date) {
    aVal = myVal.toLocaleDateString("en-US");
  } else aVal = myVal;
  return (
    <Text style={styles.gTableCellText} numberOfLines={1} ellipsizeMode="tail">
      {aVal}
    </Text>
  );
};

export const renderCellBadge: tRenderBadges = (badgeConfig, value) => {
  const kColorStyle: StyleProp<ViewStyle> = { backgroundColor: kColors.lightMed };
  if (badgeConfig.redPattern && value.match(badgeConfig.redPattern)) {
    kColorStyle.backgroundColor = kColors.red200;
  } else if (badgeConfig.orangePattern && value.match(badgeConfig.orangePattern)) {
    kColorStyle.backgroundColor = kColors.orange200;
  } else if (badgeConfig.yellowPattern && value.match(badgeConfig.yellowPattern)) {
    kColorStyle.backgroundColor = kColors.secondaryYellow;
  } else if (badgeConfig.greenPattern && value.match(badgeConfig.greenPattern)) {
    kColorStyle.backgroundColor = kColors.green200;
  } else if (badgeConfig.pinkPattern && value.match(badgeConfig.pinkPattern)) {
    kColorStyle.backgroundColor = kColors.pink;
  }

  return (
    <View style={[styles.gTableBadge, kColorStyle]}>
      <Text style={styles.gTableBadgeLabel} numberOfLines={1}>
        {value}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  gTableBadge: {
    alignItems: "center",
    borderRadius: 5,
    flexDirection: "row",
    paddingHorizontal: 6,
    paddingVertical: 1,
  },
  gTableBadgeLabel: {
    ...kFonts.bodySmallCenter,
    color: kColors.brandDark,
    fontWeight: "500",
    textTransform: "uppercase",
  },
  gTableCellText: {
    ...kFonts.body,
    flex: 1,
  },
});
